/**
* Slick Carousel - http://kenwheeler.github.io/slick/
*
* All settings for each slider are on data attributes 'data-slick'
*
* If you want the slider to be controlled by a custom navigation
* set a data attribute on each nav item to correspond to the slide
* you wish to navigate to as well as which slider on the page you
* wish to control.
*
* <ul class="js-slick-nav" data-slick-nav-for="js-product-slider">
* 	<li>
* 		<button data-slide="0">
* 			Slide one
* 		</button>
* 	</li>
* 	...
* </ul>
*
*/

// Dependencies
import $ from 'jquery';
require('slick-carousel');

// Cached elements
const $el = {
	slider: $('.js-carousel'),
	sliderNav: $('.js-carousel-nav')
};

export default function init() {
	// Initialise Slick
	$el.slider.slick({ // Settings are on data attributes
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		asNavFor: $el.sliderNav,
		autoplay: true,
		autoplaySpeed: 6000,
		adaptiveHeight: false,
		waitForAnimate: false,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					dots: true,
				}
			},
		]
	}).on('setPosition', function(){
		$el.slider.find('.c-carousel__slide-inner').matchHeight({ property: 'min-height' });
	});

	$el.sliderNav.slick({
		slidesToShow: 3,
		asNavFor: $el.slider,
		arrows: false,
		dots: false,
		focusOnSelect: true,
		adaptiveHeight: true,
	});
}

